import { render, staticRenderFns } from "./MaterialAssessment.vue?vue&type=template&id=64247fe4&scoped=true"
import script from "./MaterialAssessment.vue?vue&type=script&lang=js"
export * from "./MaterialAssessment.vue?vue&type=script&lang=js"
import style0 from "./MaterialAssessment.vue?vue&type=style&index=0&id=64247fe4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64247fe4",
  null
  
)

export default component.exports